
// Common JS
require('./src/common');

// Swipers JS
require('./src/sliders');

// Swipers JS
require('./src/frontpage');

// Woocommerce product page JS
require('./src/product');

// Woocommerce Cart & Checkout pages JS
require('./src/cart-checkout');

// Contacts page map
require('./src/contacts');

(function () {
  const hiddenEmails = document.querySelectorAll('.js-email');

  if (hiddenEmails.length === 0) return;

  for (const email of hiddenEmails) {
    email.addEventListener('click', () => {
      window.location.href =
        'mailto:' + email.dataset.name + email.dataset.domain;
    });
  }
})();
